exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container .content-cube-html,.container img{width:100%}.mobile .container,.mobile .homeContainer,.mobile .subContainer{padding:50px 0 0!important}.displayNone{display:none}.hiddenText{padding:10px;background-color:hsla(0,0%,78%,.3)}.sponsor-image-block{background-size:contain;background-repeat:no-repeat;margin-top:7px;text-align:center}.sponsorimg{width:100%!important;height:auto!important;margin:0!important}.sponsor-row{margin:10px 0 0!important}.sponsor-ticker-cube{overflow:hidden}.sponsor-ticker-title{color:#333;text-align:center;margin-bottom:15px}.sponsor-marquee{overflow:hidden;width:100%;height:120px}.sponsor-marquee__track{display:flex;align-items:center;width:max-content;will-change:transform}.left-pad{padding-left:5px}.right-pad{padding-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/home.scss
// module id = 528
// module chunks = 0